import { render } from "./FassungWaehlen.vue?vue&type=template&id=0736190d&scoped=true"
import script from "./FassungWaehlen.vue?vue&type=script&lang=js"
export * from "./FassungWaehlen.vue?vue&type=script&lang=js"

import "./FassungWaehlen.vue?vue&type=style&index=0&id=0736190d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0736190d"]])

export default __exports__